import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { PHONE_RAW } from "@/i18n/translations";

export const WhatsAppFab = () => (
  <motion.a
    data-testid="whatsapp-fab"
    href={`https://wa.me/${PHONE_RAW}`}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200 }}
    whileHover={{ scale: 1.08 }}
    className="fixed bottom-6 right-6 z-50 bg-brand hover:bg-brand-light text-white p-4 shadow-[0_8px_30px_rgba(230,0,92,0.45)] rounded-full"
    aria-label="WhatsApp"
  >
    <MessageCircle size={26} />
    <span className="absolute inset-0 rounded-full bg-brand animate-ping opacity-30" />
  </motion.a>
);
